import React from 'react';
import styled from 'styled-components';

const Logo = styled.div.attrs({
  className: 'logo',
})`
  background-image: ${props => (props.url ? `url(${props.url}) !important` : 'inherit')};
  height: 4rem;
  width: 70%;
`;

export default function (props) {
  return (
    <Logo {...props} />
  );
}
